const hasDuplicates = (array) => {
  const set = new Set(array);
  return set.size !== array.length;
};

const autosave = (store) => {
  // See big comment below
  let timeoutId;

  // Called when the store is initialized
  store.subscribe((mutation) => {
    // Called after every mutation.
    // The mutation comes in the format of `{ type, payload }`.
    const triggerMutations = [
      'ADD_INSTANCE_TO_CONTAINER',
      'REMOVE_INSTANCE_FROM_CONTAINER',
      'SET_ACTIVE_EDITABLE_OBJECT_DATA',
      'SET_INSTANCE_INDEX',
    ];

    if (
      !!store.getters.containerId &&
      !store.getters.activeGlobalData &&
      !store.getters.activeExternalGlobalInstance &&
      triggerMutations.includes(mutation.type)
    ) {
      if (mutation.type === 'SET_ACTIVE_EDITABLE_OBJECT_DATA') {
        // Vue uses the input event of input and textarea fields to update their
        // models. It means that every keystroke triggers an update. If we just
        // "forward" this stream of updates to API, we will overload it, so we add
        // a little delay of 1s before the API call. Clever, isn't?
        clearInterval(timeoutId);

        timeoutId = setTimeout(() => {
          store.dispatch('saveActiveContainer');
        }, 1000);
      } else {
        const isIndexChange = mutation.type === 'SET_INSTANCE_INDEX';

        // Avoid saving the page while the instances are being swapped
        if (
          !isIndexChange ||
          !hasDuplicates(mutation.payload.page?.instanceList)
        ) {
          // Only set true to bypass check when changing intances position
          setTimeout(() => {
            store.dispatch('saveActiveContainer', isIndexChange);
          }, 0); // this will allow the props default to be set before saving
        }
      }
    }
  });
};

export default autosave;
